export function ConnectGuideChromeOs() {
  return (
    <svg viewBox="0 0 240 220" xmlns="http://www.w3.org/2000/svg" className="w-full max-w-xs mx-auto block" aria-hidden="true">
      {/* Desktop */}
      <rect width="240" height="220" fill="#1565c0" />
      {/* Shelf at bottom */}
      <rect x="0" y="196" width="240" height="24" fill="#1a1a2e" />
      {/* App icons */}
      <circle cx="20" cy="208" r="8" fill="#4285f4" />
      <text x="20" y="212" textAnchor="middle" fontSize="9" fill="#fff">G</text>
      <circle cx="42" cy="208" r="8" fill="#34a853" />
      {/* System tray – highlighted */}
      <rect x="178" y="199" width="60" height="18" rx="4" fill="rgba(255,255,255,0.2)" stroke="rgba(255,255,255,0.5)" strokeWidth="1" />
      <text x="185" y="211" fontSize="9" fill="#fff">◈</text>
      <text x="197" y="211" fontSize="8" fill="#fff">🔊</text>
      <text x="212" y="211" fontSize="7.5" fill="#fff">9:41</text>
      {/* Arrow pointing to system tray */}
      <polygon points="208,196 202,184 214,184" fill="#ff9500" />

      {/* WiFi panel popup */}
      <rect x="90" y="30" width="148" height="158" rx="10" fill="#2d2d2d" stroke="#444" strokeWidth="0.8" />
      <text x="164" y="52" textAnchor="middle" fontSize="10" fontWeight="500" fill="#e8eaed">WLAN</text>
      <line x1="98" y1="60" x2="230" y2="60" stroke="#444" strokeWidth="0.5" />
      {/* Connected network */}
      <rect x="98" y="65" width="132" height="36" rx="5" fill="#3d3d3d" />
      <rect x="104" y="77" width="3" height="5" rx="1" fill="#8ab4f8" />
      <rect x="109" y="73" width="3" height="9" rx="1" fill="#8ab4f8" />
      <rect x="114" y="69" width="3" height="13" rx="1" fill="#8ab4f8" />
      <text x="122" y="80" fontSize="10" fill="#e8eaed" fontWeight="500">Dein-WLAN</text>
      <text x="122" y="92" fontSize="8.5" fill="#9aa0a6">Verbunden</text>
      <line x1="98" y1="105" x2="230" y2="105" stroke="#444" strokeWidth="0.3" />
      {/* Other network */}
      <rect x="98" y="109" width="132" height="34" rx="5" fill="transparent" />
      <rect x="104" y="120" width="3" height="5" rx="1" fill="#666" />
      <rect x="109" y="117" width="3" height="8" rx="1" fill="#888" />
      <rect x="114" y="113" width="3" height="12" rx="1" fill="#aaa" />
      <text x="122" y="128" fontSize="10" fill="#9aa0a6">Gäste-WLAN</text>
      <line x1="98" y1="147" x2="230" y2="147" stroke="#444" strokeWidth="0.3" />
      {/* Settings link */}
      <text x="164" y="174" textAnchor="middle" fontSize="9" fill="#8ab4f8">WLAN-Einstellungen…</text>
    </svg>
  );
}
